// extracted by mini-css-extract-plugin
module.exports = {"video_container":"Video_video_container__1zq1s","video":"Video_video__KDdiW","controls":"Video_controls__2MRdt","redo":"Video_redo__GkOK9"};